
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/gigs-services-faq",
      function () {
        return require("private-next-pages/legal/gigs-services-faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/gigs-services-faq"])
      });
    }
  